module.exports = __webpack_public_path__ + "e2db7186f7de92cfcf41d75c3468f51e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Wright.png
// module id = jpaK
// module chunks = 0